<template>
  <div class="patient-download">
    <md-toolbar class="md-primary nav-style first-nav">
      <img src="../assets/logo.png" class="logo_navbar" />
      <div class="md-toolbar-section-end nav-style">
        <md-button class="user-mail" @click="logout_active = true">
          <i class="material-icons person-icon">person</i>
        </md-button>
      </div>
    </md-toolbar>
    <div class="md-title second-navbar">COMUNICAZIONE SICURA</div>

    <md-card md-with-hover v-if="uploadFileSpinner">
      <md-card-content>
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      </md-card-content>
    </md-card>

    <md-card v-if="!uploadFileSpinner && downloadDataUrl != null">
      <md-card-content>
        <div class="md-subhead">
          Clicca sulla comunicazione che ti interessa per visualizzare il
          contenuto
        </div>

        <br />
        <md-list v-if="!smallScreen">
          <md-list-item
            v-for="item in downloadDataUrl"
            v-bind:key="item.downloadUrl"
            class="file-list-item"
          >
            <md-icon class="material-icons pdf-icon-style">attach_file</md-icon>
            <span class="md-list-item-text">{{ item.fileName }}</span>
            <span class="date-list-item">
              Inviato il
              {{ item.date | moment("DD/MM/YYYY, h:mm:ss a") }}
            </span>
            <span class="download-list-item">
              Visualizza o scarica il file
            </span>

            <md-button
              v-if="!isIE"
              class="md-icon-button download-icon-item"
              title="Visualizza"
              @click="view_file(item.fileName, item.downloadUrl)"
            >
              <md-icon>visibility</md-icon>
            </md-button>

            <md-button
              class="md-icon-button download-icon-item"
              title="Scarica"
              @click="download_file(item.fileName, item.downloadUrl)"
            >
              <md-icon>cloud_download</md-icon>
            </md-button>

            <md-button
              class="md-icon-button download-icon-item"
              title="Rispondi"
              @click="send_file(item)"
            >
              <md-icon>send</md-icon>
            </md-button>
          </md-list-item>
        </md-list>
        <md-list v-if="smallScreen">
          <md-list-item
            v-for="item in downloadDataUrl"
            v-bind:key="item.downloadUrl"
            class="file-list-item"
          >
            <md-icon
              class="material-icons pdf-icon-style"
              style="margin-right: 5px"
              >attach_file</md-icon
            >
            <span class="md-list-item-text">{{ item.fileName }}</span>

            <md-button
              class="md-icon-button download-icon-item"
              title="Scarica"
              @click="download_file(item.fileName, item.downloadUrl)"
            >
              <md-icon>cloud_download</md-icon>
            </md-button>
          </md-list-item>
        </md-list>
        <br />
        <md-button
          class="home-button md-raised md-accent normal-button"
          :md-ripple="false"
          @click="logout"
          >Esci
        </md-button>
      </md-card-content>
    </md-card>
    <div>
      <md-dialog
        :md-active.sync="showDialog"
        :md-click-outside-to-close="false"
      >
        <md-dialog-title>Scegli paziente</md-dialog-title>
        <md-dialog-content>
          Questo numero è stato registrato per diversi pazienti.<br />
          Clicca sul nome del paziente per proseguire.
          <md-list>
            <md-list-item
              v-for="item in patients"
              v-bind:key="item.id"
              @click="choosePatient(item)"
            >
              <span class="md-list-item-text"
                >{{ item.patientName }} {{ item.patientSurname }}</span
              >
            </md-list-item>
          </md-list>
        </md-dialog-content>
      </md-dialog>
      <md-dialog :md-active.sync="showFileDialog" class="file-dialog">
        <md-dialog-content>
          <div class="iframe-div">
            <iframe :src="blobUrl"></iframe>
          </div>
        </md-dialog-content>

        <md-dialog-actions>
          <md-button class="md-primary" @click="showFileDialog = false"
            >Chiudi</md-button
          >
        </md-dialog-actions>
      </md-dialog>

      <md-dialog-confirm
        :md-active.sync="logout_active"
        md-title="Disconnetti"
        md-content="Cliccando 'Conferma' verrai disconnesso e riportato alla pagina iniziale"
        md-confirm-text="Conferma"
        md-cancel-text="Annulla"
        @md-cancel="logout_active = false"
        @md-confirm="logout()"
      />
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import parsley from "parsleyjs";
import $ from "jquery";
import axios from "axios";
import moment from "moment";

export default {
  name: "PatientDownload",
  data() {
    return {
      pdfURL: "",
      name: null,
      surname: null,
      patientMail: null,
      patientBirthDate: null,
      patientId: null,
      patientTelNumber: null,
      primaryMail: null,
      secondaryMail: null,
      downloadDataUrl: [],
      uploadFileSpinner: true,
      showLogoutOptions: false,
      user: null,
      patients: [],
      showDialog: false,
      smallScreen: false,
      showFileDialog: false,
      blobUrl: "",
      logout_active: false,
      isIE: false
    };
  },
  computed: {},
  mounted: function() {
    //console.log(this.$route.query.ref)
    var self = this;
    if (
      !self.$store.state.detailPhone ||
      self.$store.state.detailPhone.length == 0
    ) {
      self.$router.push({ path: "/view-files" });
    }
    var ua = window.navigator.userAgent;
    self.isIE = /MSIE|Trident/.test(ua);
    //console.log(self.isIE);
    var window_media = window.matchMedia("(max-width: 768px)");
    self.test_match_mview(window_media);
    window_media.addListener(self.test_match_mview);
    //console.log(self.$route);
    // controllo esistenza stringa in firestorage
    // controllo auth
    self.user = firebase.auth().currentUser;
    //console.log(self.user);

    if (self.user) {
      // da mettere ciclo per controllare se + providerData
      if (self.user.providerData[0].providerId == "phone") {
        self.userPhone = self.user["phoneNumber"];
        console.log("Phone-Authenticated user");

        self.checkUserRegistration();
        //check utente codice
        //get file URL
      } else {
        self.$store.commit("setRedirectPath", self.$route.fullPath);
        console.log("User not Phone-Authenticated");
        self.$router.push("/phone-auth");
      }
    } else {
      console.log("User not Authenticated");
      self.$store.commit("setRedirectPath", self.$route.fullPath);
      self.$router.push("/phone-auth");
    }
  },
  methods: {
    send_file: function(item) {
      var self = this;
      console.log(item);
      self.$store.commit("commitReplyPatientName", self.name);
      self.$store.commit("commitReplyPatientSurname", self.surname);
      self.$store.commit("commitReplyPatientMail", self.patientMail);
      self.$store.commit("commitReplyPatientTelNumber", self.patientTelNumber);
      self.$store.commit("commitReplyPatientId", self.patientId);
      self.$router.push("/registration-upload");
    },
    test_match_mview: function(window_media) {
      var self = this;
      //console.log("test_match_view");
      if (window_media.matches) {
        self.smallScreen = true;
        //console.log("small");
        //console.log(self.smallScreen);
      } else {
        self.smallScreen = false;
        //console.log("large");
        //console.log(self.smallScreen);
      }
    },
    download_file(filename, url) {
      var self = this;
      //console.log('download');
      //console.log(filename);
      //console.log(url);
      var storage = firebase.storage();
      var httpsReference = storage.refFromURL(url);
      httpsReference
        .getDownloadURL()
        .then(function(file_url) {
          //console.log(file_url);
          //console.log('storage download');
          fetch(file_url)
            .then(r => r.blob())
            .then(blob => self.showFile(blob, filename));

          /*
          var ua = window.navigator.userAgent;
          var isIE = /MSIE|Trident/.test(ua);
          console.log(isIE);
          var xhr = new XMLHttpRequest();
          console.log('creazione xhr');
          xhr.responseType = "blob";
          if ( isIE ) {
            console.log('IE');
            axios({
              method: 'get',
              url: file_url,
              responseType: 'blob'
            })
              .then(function (response) {
                console.log('mssaveoropenblob');
                window.navigator.msSaveOrOpenBlob(response.data, filename);
              });
            //IE specific code goes here

          }
          else{
            xhr.onload = function(event) {
            console.log('xhr onload');

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              console.log('mssaveoropenblob');
              window.navigator.msSaveOrOpenBlob(xhr.response, filename);
            } else {
              console.log('no ms');
              var a = document.createElement("a");
              var link = window.URL.createObjectURL(xhr.response);
              console.log(link);
              a.href = link;

              //a.target = "_blank";
              a.download = filename;
              a.style.display = "none";
              document.body.appendChild(a);
              console.log('click');
              //a.click();
              document.body.removeChild(a);
            }

          };
          xhr.open("GET", file_url);
          xhr.send();
          }*/
        })
        .then(function(data) {
          axios
            .post(
              "/logging",
              {
                component: "PAZIENTE",
                event: "Download file",
                patientName: self.name,
                patientSurname: self.surname,
                patientEmail: self.patientMail,
                patientNumber: self.patientTelNumber,
                description: filename + " - " + url
              },
              {
                headers: {
                  //Authorization: 'Bearer ' + idToken
                }
              }
            )
            .then(function(data) {
              //console.log("SUCCESS!!");
            })
            .catch(function() {
              //console.log("FAILURE!!");
            });
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    view_file: function(filename, url) {
      var self = this;
      var storage = firebase.storage();
      var httpsReference = storage.refFromURL(url);
      httpsReference.getDownloadURL().then(function(file_url) {
        var xhr = new XMLHttpRequest();
        xhr.responseType = "blob";
        xhr.onload = function(event) {
          self.blobUrl = window.URL.createObjectURL(xhr.response);
          self.showFileDialog = true;
          axios
            .post(
              "/logging",
              {
                component: "PAZIENTE",
                event: "Visualizzazione file",
                patientName: self.name,
                patientSurname: self.surname,
                patientEmail: self.patientMail,
                patientNumber: self.patientTelNumber,
                description: filename + " - " + url
              },
              {
                headers: {
                  //Authorization: 'Bearer ' + idToken
                }
              }
            )
            .then(function(data) {
              //console.log("SUCCESS!!");
            })
            .catch(function() {
              //console.log("FAILURE!!");
            });
        };
        xhr.open("GET", file_url);
        xhr.send();
      });
      /*window.open(
        "/download_test?user=" + self.patientId + "&file=" + filename,
        "_blank",
        "location=yes,height=570,width=520,scrollbars=yes,status=yes"
      );*/
      /*
      var html_string =
        "<iframe width='100%' height='100%' src='" + url + "'></iframe>";
      let pdfWindow = window.open("");
      pdfWindow.document.write(html_string);*/

      /*
      this.user.getIdToken().then(idToken => {

        axios
          .post(
            "/download",
            {
              user_id: self.user["uid"],
              folder: self.patientId,
              filename: filename,
              url: url
            },
            {
              headers: {
                Authorization: "Bearer " + idToken
              }
            }
          )
          .then(function(response) {
            var fileContent = response["data"]["content"];
            var mimetype = response["data"]["mimetype"];
            var file_string = encodeURI(fileContent);
            var html_string =  "<iframe width='100%' height='100%' src='data:" +
                                mimetype +
                                ";base64, " +
                                file_string +
                                "'></iframe>"
            let pdfWindow = window.open("");



            pdfWindow.document.write(html_string);
            axios
            .post(
                "/logging",
                {
                  component: "PAZIENTE",
                  event: "Visualizzazione file",
                  patientName : self.name,
                  patientSurname : self.surname,
                  patientEmail: self.patientMail,
                  patientNumber: self.patientTelNumber,
                  description: filename


                },
                {
                  headers: {
                    //Authorization: 'Bearer ' + idToken
                  }
                }
              )
              .then(function(data) {
                console.log("SUCCESS!!");
              })
              .catch(function() {
                console.log("FAILURE!!");
              });
          })
          .catch(function(error) {
            //self.addResourceError();
            console.error("ERROR: " + error);
          });

      });*/
    },
    showFile: function(blob, filename) {
      //console.log(blob);
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([blob], { type: blob.type });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.download = filename;
      link.click();
      setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    dynamicSort: function(property) {
      var sortOrder = 1;
      if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function(a, b) {
        /* next line works with strings and numbers,
         * and you may want to customize it to your needs
         */
        var result =
          a[property] > b[property] ? -1 : a[property] < b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    getFileFromHumanitas: function(id) {
      var self = this;
      axios
        .post(
          "/getHistory",
          {
            collectionName: "fromHumanitas",
            patientMail: self.patientMail,
            patientId: id,
            patientName: self.name,
            patientSurname: self.surname
          },
          {
            headers: {
              //Authorization: 'Bearer ' + idToken
            }
          }
        )
        .then(function(data) {
          console.log("SUCCEEESSS!!!");
          console.log(data.data.data);
          self.uploadFileSpinner = false;
          self.downloadDataUrl = data.data.data;
        })
        .catch(function(error) {
          console.log("FAILURE!!");
          //console.log(error);
        });
    },
    logout: function() {
      var self = this;
      firebase
        .auth()
        .signOut()
        .then(function() {
          self.$router.push({
            path: "/view-files"
          });
        });
    },
    choosePatient: function(item) {
      var self = this;
      //console.log("choosepatient");
      self.patientId = item.id;
      self.name = item.patientName;
      self.surname = item.patientSurname;
      self.patientMail = item.patientMail;
      self.patientBirthDate = item.patientBirthDate;
      self.patientTelNumber = item.patientTelNumber;
      if (self.showDialog) self.showDialog = false;
      axios
        .post(
          "/logging",
          {
            component: "PAZIENTE",
            event: "Login e accetazione trattamento dati",
            patientName: self.name,
            patientSurname: self.surname,
            patientEmail: self.patientMail,
            patientNumber: self.patientTelNumber
          },
          {
            headers: {
              //Authorization: 'Bearer ' + idToken
            }
          }
        )
        .then(function(data) {
          //console.log("SUCCESS!!");
        })
        .catch(function() {
          //console.log("FAILURE!!");
        });
      self.getFileFromHumanitas(self.patientId);
    },
    checkUserRegistration: function() {
      var self = this;

      console.log("checkUserRegistration");
      console.log(self.$store.state.detailPhone);

      axios
        .get("/patientsFromNumber/" + self.$store.state.detailPhone, {
          headers: {
            //Authorization: 'Bearer ' + idToken
          }
        })
        .then(function(data) {
          console.log("SUCCESS - qui   !!");
          console.log(data.data.data);
          var patients_list = data.data.data;
          if (patients_list.length > 1) {
            self.patients = patients_list;
            self.showDialog = true;
          } else if (patients_list.length == 1) {
            self.choosePatient(patients_list[0]);
          }

          //self.patientMail = data.data.data["patientMail"];
          //self.patientTelNumber = data.data.data["patientTelNumber"];
          //self.id_patient = self.patientID;
        })
        .catch(function() {
          //console.log("FAILURE!!");
        });
    },
    getUserInfo: function() {
      var self = this;
      axios
        .post(
          "/getUserInfo",
          {
            userPhone: self.userPhone
          },
          {
            headers: {
              //Authorization: 'Bearer ' + idToken
            }
          }
        )
        .then(function(data) {
          //console.log("SUCCESS");
          //console.log(data);
          if (data) {
            //console.log(data.data.data);
            var rawData = data.data.data;

            self.name = rawData["patientName"];
            self.surname = rawData["patientSurname"];
            self.patientMail = rawData["patientMail"];

            //var pdfLinks = self.getFileFromHumanitas(self.patientMail);
          } else {
            //console.log("non trovato");
            self.$router.push({ path: "/view-files" });
          }
        })
        .catch(function(e) {
          //console.log("User Info retrieving failed because: ", e);
          self.$notify({
            group: "foo",
            title: "Errore dati",
            text:
              "Sembra che ci siano prolemi nell'ottenere le informazioni sull'utente. Prego contattare l'amministratore per ottenere i dettagli",
            duration: 300,
            closeOnClick: true,
            max: 1
          });
        });
    }
  }
};
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */
.logout {
  margin-top: 40px;
}

input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}

.home-button {
  width: 30%;
}

.md-card {
  width: 80%;
  margin: 4px;
  display: inline-block;
  vertical-align: center;
}

.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.nav-style {
  height: 50px;
}

.second-navbar {
  background-color: #027953;
  font-size: 26px;
  font-weight: bold;
  color: #ffffff;
  padding: 1.3%;
}

.title-style {
  color: #027953;
}

.first-nav {
  background-color: #ffffff !important;
}

.pdf-icon-style {
  float: left !important;
  color: #ea5b0c !important;
}

.user-mail {
  background-color: #f2f1f2;
  text-transform: lowercase;
  border-radius: 22px;
}

.person-icon {
  color: #027953;
}

.file-list-item:hover {
  background-color: var(
    --md-theme-default-divider-on-background,
    rgba(0, 0, 0, 0.12)
  );
}

.download-list-item {
  display: none;
}

.download-icon-item {
  display: none;
}

.file-list-item:hover .download-icon-item {
  display: inline-block;
}

.file-list-item:hover .download-list-item {
  display: inline-block;
}

.file-list-item:hover .date-list-item {
  display: none;
}

.file-dialog {
  width: 60%;
  height: 80%;
}

.file-dialog .iframe-div {
  display: flex;
  width: 100%;
  height: 100%;
}

.file-dialog .iframe-div iframe {
  width: 100%;
  height: 100%;
}

@media only screen and (max-width: 600px) {
  .file-dialog {
    width: auto;
    height: auto;
  }

  .md-card {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PatientDownload.vue